import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Use SVG animate tag to animate d attribute of path (overlay and highlighted border)
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/SVG/Element/animate}
 */
export const UITourPulserAnimate = ({
  duration,
  values
}) => {
  return /*#__PURE__*/_jsx("animate", {
    attributeName: "d",
    calcMode: "spline",
    dur: duration,
    repeatCount: "indefinite",
    values: values,
    keyTimes: "0; 0.5; 1"
    // Use keySplines for pulser easing: ease-out for expand, ease-in for shrink
    // https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/keySplines
    ,
    keySplines: "0.61,1,0.88,1; 0.37,0,0.63,1"
  });
};

/**
 * Use SVG filter to create a drop shadow for the highlighted border
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/SVG/Element/feDropShadow}
 */
export const UITourPulserBorderShadow = ({
  borderColor,
  borderShadowId
}) => {
  return /*#__PURE__*/_jsx("filter", {
    id: borderShadowId,
    children: /*#__PURE__*/_jsx("feDropShadow", {
      dx: "0",
      dy: "0",
      floodColor: borderColor,
      stdDeviation: "3"
    })
  });
};